import { Component, OnInit } from "@angular/core";
import { environment } from "src/environments/environment";
import { HttpClient } from "@angular/common/http";
import { GeolocationService } from "../services/geolocationservice";
import { sweetalert } from "../services/sweetalert";
import { Router } from "@angular/router";

@Component({
  selector: "app-dealer-details",
  templateUrl: "./dealer-details.component.html",
  styleUrls: ["./dealer-details.component.css"],
})
export class DealerDetailsComponent implements OnInit {
  selectedstoredata: any;
  dealerData: any;
  imageBase64:any;
  pdfDownloadLink:any;

  responseData:any;
  loader:boolean=false;
  encrpyData:any;
  disabledButton:boolean=false;
  dealerCode:any;
  lat:any;
  lng:any;
  constructor(
    private httpClient: HttpClient,
    private alert: sweetalert,
    private service: GeolocationService,
    private route: Router
  ) {}

  ngOnInit(): void {
    this.selectedstoredata = JSON.parse(localStorage.getItem("selectedDealer"));
    this.encrpyData=localStorage.getItem("encrpyData");
    this.lat=localStorage.getItem("ml_lat");
    this.lng=localStorage.getItem("ml_lng");
    console.log("selectedstoredata:" + JSON.stringify(this.selectedstoredata));
    this.dealerData = JSON.parse(
      localStorage.getItem("dealerData")
    ).DEALERS.filter(
      (e) => e.DEALER_CODE != this.selectedstoredata.DEALER_CODE
    );
    console.log("selected", this.selectedstoredata.DEALER_CODE);
    console.log("dealer", this.dealerData);
  }
  getPreApprovalLetter() {
    this.dealerCode=this.selectedstoredata.DEALER_CODE;
    console.log("dealerCode:"+this.dealerCode);
    this.loader = true;
    this.disabledButton=true;
    let reqObj={
      encrpyData:this.encrpyData,
      merchantDetails:this.selectedstoredata
    }
    this.service.getPreApprovalLetter(reqObj).subscribe(
      (data: any) => {
        if (typeof data === "object") {
          console.log("responseData:" + JSON.stringify(data));
          if (data.statusCode == "EX") {
            setTimeout(() => {
              this.loader = false;
            }, 1000);
            this.alert.errorsweertalert(data.statusMessage);
            this.disabledButton=false;
          } else if (data.statusCode == "SR") {
            this.responseData = JSON.parse(data.data);
            // this.imageBase64= this.responseData.image;
            let mailReqObj={
              encrpyData:this.encrpyData,
              dealerCode:this.dealerCode,
              url:this.responseData.smsurl
            }
            this.service.sendMailToDealer(mailReqObj).subscribe(
              (data: any) => {
                if (typeof data === "object") {
                  console.log("Mail res data:" + JSON.stringify(data));
                }
              })
            this.pdfDownloadLink=this.responseData.smsurl;
            window.location.href=this.pdfDownloadLink;
            console.log("responseData:" + JSON.stringify(this.responseData));
            console.log("pdfDownloadLink:" + this.pdfDownloadLink);
            //document.getElementById("hiddenButton").click();
            this.loader = false;
            this.disabledButton=false;
            
          }
        }
      },
      (error: Response) => {
        this.alert.errorsweertalert("Something went wrong");
        this.loader = false;
        this.disabledButton=false;
      }
    );

    let Obj = {
      data:this.encrpyData, 
      merchantDet: this.selectedstoredata,
      lat:this.lat,
      lng:this.lng
    };
    this.httpClient
      .post(environment.baseUrl + "/tvsm/saveMerchantStoreLogs", Obj)
      .toPromise()
      .then((data) => {
        console.log("data", data);
      });
  }

  getDirection(item: any) {
    console.log("Inside direction block");
    console.log("lat:"+item.LAT)
    console.log("lng:"+item.LANG)
    alert("lat:"+item.LAT+" lng:"+item.LANG);
    



    // @ts-ignore
    Dialog.showMsg(item.LAT, item.LANG);
  }

  changeSelectedDealer(data: any) {
    this.selectedstoredata = data;
    console.log("upadted dealer", JSON.stringify(this.selectedstoredata));
    localStorage.setItem(
      "selectedDealer",
      JSON.stringify(this.selectedstoredata)
    );
    this.dealerData = JSON.parse(
      localStorage.getItem("dealerData")
    ).DEALERS.filter(
      (e) => e.DEALER_CODE != this.selectedstoredata.DEALER_CODE
    );
  }
  goBack(){
    this.route.navigate(["/dealers"]);
  }
}
